/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RadiusFilter
 */
export interface RadiusFilter {
    /**
     * 
     * @type {string}
     * @memberof RadiusFilter
     */
    type: RadiusFilterTypeEnum;
    /**
     * Center point latitude.
     * @type {number}
     * @memberof RadiusFilter
     */
    latitude: number;
    /**
     * Center point longitude.
     * @type {number}
     * @memberof RadiusFilter
     */
    longitude: number;
    /**
     * Distance from center in miles.
     * @type {number}
     * @memberof RadiusFilter
     */
    distance: number;
}


/**
 * @export
 */
export const RadiusFilterTypeEnum = {
    RadiusFilter: 'RadiusFilter'
} as const;
export type RadiusFilterTypeEnum = typeof RadiusFilterTypeEnum[keyof typeof RadiusFilterTypeEnum];


/**
 * Check if a given object implements the RadiusFilter interface.
 */
export function instanceOfRadiusFilter(value: object): value is RadiusFilter {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('distance' in value) || value['distance'] === undefined) return false;
    return true;
}

export function RadiusFilterFromJSON(json: any): RadiusFilter {
    return RadiusFilterFromJSONTyped(json, false);
}

export function RadiusFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): RadiusFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'distance': json['distance'],
    };
}

export function RadiusFilterToJSON(json: any): RadiusFilter {
    return RadiusFilterToJSONTyped(json, false);
}

export function RadiusFilterToJSONTyped(value?: RadiusFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'distance': value['distance'],
    };
}

